module.exports = require("remark-comment-blocks");


//////////////////
// WEBPACK FOOTER
// external "remark-comment-blocks"
// module id = 53
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13